import consumer from "./consumer"
import CableReady from "cable_ready"

consumer.subscriptions.create("RunpodMachineDataChannel", {
    connected() {
        console.log("connected to vast machine channel");
    },
    disconnected() {
        // Called when the subscription has been terminated by the server
    },
    received(data) {
        if (data.cableReady) {
            // Filter out operations where the DOM element does not exist
            const validOperations = data.operations.filter((operation) => {
                return operation.selector ? document.querySelector(operation.selector) : true;
            });

            // Perform the operations only on existing DOM elements
            if (validOperations.length > 0) {
                CableReady.perform(validOperations);
            }
        }
    }
});